import type { SetupVisibilityAndFocusHandlersParams } from './setupVisibilityAndFocusListener.types';

export const setupVisibilityAndFocusListeners = ({
  onFocus,
  onVisibilityChange,
}: SetupVisibilityAndFocusHandlersParams) => {
  window.addEventListener('focus', onFocus);
  document.addEventListener('visibilitychange', onVisibilityChange);

  return () => {
    window.removeEventListener('focus', onFocus);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
};
